<template>
  <div>
    <dashboard-header :text="$t('ui.detailEmployee')" :on-back="onGoBack" />

    <div class="d-flex align-content-center justify-content-center">
      <v-card elevation="0" :loading="loading" class="card-border-10 mx-16 w-75">
        <div class="pa-5">
          <data-detail data-colon :items="items" :headers="tableHeaders" />
        </div>

      </v-card>
    </div>

  </div>
</template>

<script>
import { API2 } from "../../api";
import DataDetail from "../base/DataDetail.vue";
import mixin from "../../mixin";
import DashboardHeader from "../component/DashboardHeader";
import { mapState } from "vuex";

export default {
  components: {DashboardHeader, DataDetail},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    },
  },
  data() {
    return {
      detail: null,
      detailHospital: null,
    };
  },
  mounted() {
    this.onTab(this.item)
  },
  computed: {
    ...mapState(['locale']),
    tableHeaders() {
      return [
        {key: 'title', label: this.$t('base.title'), thStyle: {width: '50%'}},
        {key: 'data', label: this.$t('base.content')}
      ]
    },
    items() {
      return [
        {
          title: this.$t('employee.name'),
          data: this.detail ? this.detail.name : ''
        },
        {
          title: this.$t('account.username'),
          data: this.detail ? this.detail.username || this.detail.email?.split('@')[0] : ''
        },
        {
          title: this.$t('account.email'),
          data: this.detail ? this.detail.email : ''
        },
        {
          title: this.$t('employee.phoneNumber'),
          data: this.detail ? this.detail.phoneNumber : ''
        },
        {
          title: this.$t('employee.title'),
          data: this.detail && this.detail.title ? this.detail.title.name : ''
        },
        {
          title: this.$t('employee.department'),
          data: this.detail && this.detail.department ? this.detail.department.name : ''
        },
        {
          title: this.$t('employee.inCharge'),
          data: this.detail && this.detail.inCharge === 1
              ? this.$t('base.yes')
              : this.$t('base.no')
        },
        {
          title: this.$t('ui.redAlertMobile'),
          data: this.detail && this.detail.doctorSosCall === 1
              ? this.$t('setting.activated')
              : this.$t('setting.inActivated')
        },
        {
          title: this.$t('ui.activeNurseMobile'),
          data: this.detail && this.detail.isGetNotifications === 1
              ? this.$t('setting.activated')
              : this.$t('setting.inActivated')
        },
        {
          title: this.$t('base.createdAt'),
          data: this.detail ? this.formatDate(this.detail.createdAt) : ''
        },
        {
          title: this.$t('base.updatedAt'),
          data: this.detail ? this.formatDate(this.detail.updatedAt) : ''
        }
      ];
    }
  },
  methods: {
    onTab(item) {
      if (item) this.getData(item)
    },
    async getData(item) {
      this.detail = null
      let res = await this.get(API2.EMPLOYEE, { path: item.data.employeeId })
      if (res) {
        this.detail = res;
      } else {
        // No data returned from API, redirect back to list
        this.onGoBack();
      }
    },
    onGoBack() {
      this.openTab(0)
    }
  }
};
</script>

<style scoped>
.info {
  color: #595959;
}
</style>
